import React from 'react';
import { FaPaperPlane, FaGithub, FaLinkedin, FaFacebook, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    alert(`Thank you for subscribing with email: ${email}`);
    e.target.reset();
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <a href="#home" className="logo">Nirmal<span>Dhakal</span></a>
            <p>Designing & Developing the Future, One Line of Code at a Time</p>
          </div>

          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-newsletter">
            <h3>Stay Updated</h3>
            <p>Subscribe to my newsletter for latest updates</p>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input type="email" name="email" placeholder="Enter your email" required />
              <button type="submit"><FaPaperPlane /></button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 Nirmal Dhakal. All rights reserved.</p>
          <div className="footer-social">
            <a href="https://github.com/nirmaldhakal2003" target="_blank" rel="noopener noreferrer">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/nirmaldhakal2003/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://www.facebook.com/nirmaldhakal2059" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://www.youtube.com/@Nirrach2062" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;